export default "__VITE_ASSET__f6c931fe__"